import { createSlice } from '@reduxjs/toolkit';

import { TCredentialResponse } from '@/types/credentials';

export interface ICredentialsReducer {
  credentials: TCredentialResponse;
}

const initialState = {
  credentials: {
    items: [],
    pagination: {
      page: 1,
      limit: 5,
      totalPages: 1,
    },
  },
} as unknown as ICredentialsReducer;

export const credentialsSlice = createSlice({
  name: 'credentials',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.credentials = action.payload;
    },
  },
});

export const { setCredentials} = credentialsSlice.actions;
